import { styled } from 'styled-components'

export const StyledLink = styled.span`
  color: ${({ theme }) => theme.colors.secondary};
  cursor: pointer;

  div {
    display: inline;
    vertical-align: middle;
  }
`

export const StyledUl = styled.ul`
  padding-left: 48px;
`
